// extracted by mini-css-extract-plugin
export default {"wrap":"wrap___WGyBV","slicedBackground":"slicedBackground___R7QdE","container":"container___wT3tk","delimiter":"delimiter___y1a8s"};